import { createQueryKeys } from '@lukemorales/query-key-factory'

import type { Profession } from 'src/shared/features/users/schemas/profession'

export type MySharesParams = {
  direction: 'sent' | 'received'
  statuses: string[]
  searchQuery?: string
  isClosed?: boolean
  referralId?: number
  profession?: Profession
  userId?: number
}

export const referralShares = createQueryKeys('referralShares', {
  detail: (shareId: number) => [shareId],
  list: (params: MySharesParams) => [{ params }],
  search: (query: string) => [query],
})
